import { JobMatchesQueryFilter } from 'src/app/public/app/models/jobMatchesQueryFilter';

export class CandidatesInfiniteScrollContainer {

  workflowStep: any;
  workflowStepVariable: any;
  uiIdentifier: any;
  userId: any;
  companyId: any;
  jobId: any;
  globalQueryFilter: any;
  workflowStepNames: any;

  jobMatchDragAndDropService: any;
  jobMatchService: any;
  alertsAndNotificationsService: any;

  candidates: any[];
  candidatesExistFlag: boolean;
  busy: boolean;
  disableInfiniteScroll: boolean;
  isFilterOn: boolean;
  jobMatchesQueryFilter: any;
  currentPromise: any;
  allowedDnDTypes: any[];
  isCollapsedFlag: boolean;
  showCollapseIconFlag: boolean;
  expandCollapseLabel: string;
  countAndLabelTooltipPlacement: string;
  totalCandidateCount: any;
  pageNum: number;
  pageSize: number;
  selectAllJobMatchesFlag: boolean;

  constructor(
    workflowStep: any,
    workflowStepVariable: any,
    uiIdentifier: any,
    userId: any,
    companyId: any,
    jobId: any,
    globalQueryFilter: any,
    workflowStepNames: any,
    jobMatchDragAndDropService: any,
    jobMatchService: any,
    alertsAndNotificationsService: any
  ) {
    this.workflowStep = workflowStep;
    this.workflowStepVariable = workflowStepVariable;
    this.uiIdentifier = uiIdentifier;
    this.userId = userId;
    this.companyId = companyId;
    this.jobId = jobId;
    this.globalQueryFilter = globalQueryFilter;
    this.workflowStepNames = workflowStepNames;

    this.jobMatchDragAndDropService = jobMatchDragAndDropService;
    this.jobMatchService = jobMatchService;
    this.alertsAndNotificationsService = alertsAndNotificationsService;

    this._initialize();
  }

  // Not an Angular component (it's a plain data container instantiated with `new`), so
  // there is no ngOnInit lifecycle hook to hook into - this is just a regular init method.
  private _initialize() {
    this.candidates = [];
    this.candidatesExistFlag = true;
    this.busy = false;
    this.disableInfiniteScroll = false;
    this.isFilterOn = false;

    this.jobMatchesQueryFilter = new JobMatchesQueryFilter([this.workflowStep]);
    this.jobMatchesQueryFilter.searchString = this.globalQueryFilter.searchString;
    this.jobMatchesQueryFilter.jobMatchIds = this.globalQueryFilter.jobMatchIds;
    this.jobMatchesQueryFilter.isUnassigned = this.globalQueryFilter.isUnassigned;
    this.jobMatchesQueryFilter.isAssignedToOthers = this.globalQueryFilter.isAssignedToOthers;
    this.jobMatchesQueryFilter.isAssignedToMe = this.globalQueryFilter.isAssignedToMe;
    this.jobMatchesQueryFilter.workflowStates = this.globalQueryFilter.workflowStates;
    this.jobMatchesQueryFilter.outreachStateFilters = this.globalQueryFilter.outreachStateFilters;
    this.jobMatchesQueryFilter.vendors = this.globalQueryFilter.vendors;

    this.currentPromise = null;
    this.allowedDnDTypes = this.jobMatchDragAndDropService.getAllowedDraggableTypesOfCurrentWorkflowStep(this.workflowStep, this.workflowStepNames);
    this.isCollapsedFlag = false;
    this.showCollapseIconFlag = true;
    this.expandCollapseLabel = 'Collapse Column';
    this.countAndLabelTooltipPlacement = 'bottom-right';
    this.totalCandidateCount = '..';
    this.pageNum = 1;
    this.pageSize = 5;
  }

  getNext() {
    if (this.busy) { return; }
    this.busy = true;

    this._setIsFilterOn();
    this.currentPromise = this.jobMatchService.getJobMatchCandidates(this.userId, this.companyId, this.pageNum, this.pageSize, this.jobId, this.jobMatchesQueryFilter, (data: any) => {
      if (data !== undefined && data !== null && data !== 'user cancellation') {
        this.totalCandidateCount = data.totalCardCount;
        const candidatesArray = JSON.parse(data[this.workflowStepVariable]);
        if (candidatesArray.length > 0) {
          candidatesArray.forEach((val: any) => {
            val.selectedFlag = this.selectAllJobMatchesFlag;
            val.disabledFlag = false;
            val.currentStep = this.workflowStep;
            this.setCandidateOutreachDisabled(val);
            this.candidates.push(val);
          });
          if (candidatesArray.length < this.pageSize) {
            this.disableInfiniteScroll = true;
          } else {
            this.pageNum++;
          }
        } else {
          this.disableInfiniteScroll = true;
        }
      }
      this.busy = false;
      this.currentPromise = null;
      this.candidatesExistFlag = this.candidates.length > 0;
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      this.busy = false;
      this.disableInfiniteScroll = true;
      this.currentPromise = null;
    });
  }

  private _setIsFilterOn() {
    const filter = this.jobMatchesQueryFilter;
    if (filter.jobMatchIds.length > 0
      || filter.workflowStates.length > 0
      || filter.vendors.length > 0
      || filter.searchString.length > 0
      || !filter.isAssignedToMe
      || !filter.isAssignedToOthers
      || !filter.isUnassigned) {
      this.isFilterOn = true;
    } else {
      this.isFilterOn = false;
    }
  }

  setCandidateOutreachDisabled(candidate: any) {
    candidate.isOutreachDisabled = false;
  }
}
